import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetPropertiesState } from 'src/app/asset-details/asset-property-state/asset-properties.state';
import { ComponentBaseDirective } from '../../component.base';
import { IContent, IMenuModel } from '../models/IMenuModel';
import { PropertiesOverview } from '../properties-overview';

@Component({
    selector: 'app-properties-tree-view',
    templateUrl: './properties-tree-view.component.html',
    styleUrls: ['../../properties-overview/properties-overview.component.scss'],
    standalone: false,
})
export class PropertiesTreeViewComponent extends ComponentBaseDirective {
    @Input() public treeDataSubmenus: IMenuModel[];
    @Input() public treeDataContent: IContent[];
    @Output() public menuItemClicked = new EventEmitter<string>();
    @Input() public hierarchyPath: string;

    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    public reportedProperties$: Observable<any> = this.store.select(AssetPropertiesState.getReportedPropertyValues);
    constructor() {
        super();
    }

    public onMenuClick(menuId: string) {
        this.menuItemClicked.emit(menuId);
    }

    public getToggleState(elementId: string): boolean {
        return PropertiesOverview.getToggleState(elementId);
    }

    public toggle(menuId: string) {
        PropertiesOverview.toggle(menuId);
    }

    public checkMenuCondition(menu: IMenuModel): Observable<boolean> {
        return this.reportedProperties$.pipe(
            map((props) => {
                if (!('condition' in menu)) {
                    // If menu doesnt have condition, show always the menu
                    return true;
                }

                const condition = menu.condition;

                if (!(condition.variableId in props)) {
                    return false;
                }

                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const value = this.convertConditionValueToInt(props[condition.variableId as any]);
                return value == condition?.value;
            })
        );
    }

    private convertConditionValueToInt(input: number | boolean) {
        return typeof input == 'boolean' ? (input ? 1 : 0) : input;
    }

    public checkSubMenusConditions(menu: IMenuModel): Observable<boolean> {
        return this.reportedProperties$.pipe(
            map(() => {
                // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                const submenus: any[] = menu.submenus;

                return submenus.reduce((accumulator, menu) => accumulator && this.checkMenuCondition(menu), true);
            })
        );
    }
}
